import { render } from "./EventRecorder.vue?vue&type=template&id=2576411a"
import script from "./EventRecorder.vue?vue&type=script&lang=js"
export * from "./EventRecorder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__